"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSectionBlogsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Admin" | "Comment(3)" */
    pText: ReactNode;
    /** Detected variants: "isax isax-tag-user5" | "isax isax-messages-15" */
    className: string;
    /** Detected variants: "blog-text" */
    pClassName?: string;
};

type BlogSectionBlogs2Item = {
    key: Key | null | undefined;
    /** Detected variants: "Admin" | "Comment(3)" */
    pText: ReactNode;
    /** Detected variants: "isax isax-tag-user5" | "isax isax-messages-15" */
    className: string;
    /** Detected variants: "blog-text" */
    pClassName?: string;
};

type BlogSectionBlogs3Item = {
    key: Key | null | undefined;
    /** Detected variants: "Admin" | "Comment(3)" */
    pText: ReactNode;
    /** Detected variants: "isax isax-tag-user5" | "isax isax-messages-15" */
    className: string;
    /** Detected variants: "blog-text" */
    pClassName?: string;
};
export type HomeFifteenBlogSectionGeneratedProps = {
    /** Default: "2s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our Blog & News" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Discover Trends, Tips, And" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Industry News" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "2s" */
    sectionDiv0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "blog" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/blog/blog-img-4.jpg" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1Div0Div0Div1H30H3Visible?: boolean;
    sectionDiv0Div1Div0Div0Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div1Div0Div0Div1H30Link0LinkHref?: string;
    /** Default: "Finding Balance: Simple Ways To Improve Your Mental Health" */
    sectionDiv0Div1Div0Div0Div1H30Link0LinkText?: ReactNode;
    sectionDiv0Div1Div0Div0Div1H30Link0LinkVisible?: boolean;
    sectionDiv0Div1Div0Div0Div1H30Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div1Div0Div0Div1Link0LinkHref?: string;
    /** Default: "Trauma & Recovery" */
    sectionDiv0Div1Div0Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div1Div0Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div1Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Learn More" */
    sectionDiv0Div1Div0Div0Div1Link1LinkAriaLabel?: string;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div1Div0Div0Div1Link1LinkHref?: string;
    /** Default: "Learn More" */
    sectionDiv0Div1Div0Div0Div1Link1LinkText?: ReactNode;
    sectionDiv0Div1Div0Div0Div1Link1LinkVisible?: boolean;
    sectionDiv0Div1Div0Div0Div1Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div1Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "2s" */
    sectionDiv0Div1Div1Div0DivDataWowDuration?: string;
    sectionDiv0Div1Div1Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div1Div1Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div1Div1Div0Div0H30Link0LinkHref?: string;
    /** Default: "Building Emotional Strength For Our Lives Through Self Care" */
    sectionDiv0Div1Div1Div0Div0H30Link0LinkText?: ReactNode;
    sectionDiv0Div1Div1Div0Div0H30Link0LinkVisible?: boolean;
    sectionDiv0Div1Div1Div0Div0H30Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div1Div1Div0Div0Link0LinkHref?: string;
    /** Default: "Addiction & Recovery" */
    sectionDiv0Div1Div1Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div1Div1Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div1Div1Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Learn More" */
    sectionDiv0Div1Div1Div0Div0Link1LinkAriaLabel?: string;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div1Div1Div0Div0Link1LinkHref?: string;
    /** Default: "Learn More" */
    sectionDiv0Div1Div1Div0Div0Link1LinkText?: ReactNode;
    sectionDiv0Div1Div1Div0Div0Link1LinkVisible?: boolean;
    sectionDiv0Div1Div1Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "blog" */
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/blog/blog-img-5.jpg" */
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "2s" */
    sectionDiv0Div1Div2Div0DivDataWowDuration?: string;
    /** Default: "blog" */
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/blog/blog-img-6.jpg" */
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1Div2Div0Div1H30H3Visible?: boolean;
    sectionDiv0Div1Div2Div0Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div1Div2Div0Div1H30Link0LinkHref?: string;
    /** Default: "The Importance Of Mental Health In Everyday Life Explained" */
    sectionDiv0Div1Div2Div0Div1H30Link0LinkText?: ReactNode;
    sectionDiv0Div1Div2Div0Div1H30Link0LinkVisible?: boolean;
    sectionDiv0Div1Div2Div0Div1H30Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div1Div2Div0Div1Link0LinkHref?: string;
    /** Default: "Mental Health Awareness" */
    sectionDiv0Div1Div2Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div1Div2Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div1Div2Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Learn More" */
    sectionDiv0Div1Div2Div0Div1Link1LinkAriaLabel?: string;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div1Div2Div0Div1Link1LinkHref?: string;
    /** Default: "Learn More" */
    sectionDiv0Div1Div2Div0Div1Link1LinkText?: ReactNode;
    sectionDiv0Div1Div2Div0Div1Link1LinkVisible?: boolean;
    sectionDiv0Div1Div2Div0Div1Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div2Div0Div1Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "round-element-1" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/round-element-3.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "round-element-1" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-img-two.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "round-element-1" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-img-two.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    blogSectionBlogs: BlogSectionBlogsItem[];
    blogSectionBlogs2: BlogSectionBlogs2Item[];
    blogSectionBlogs3: BlogSectionBlogs3Item[];
    blogSectionBlogsItemWrapper?: (item: BlogSectionBlogsItem, content: ReactNode) => ReactNode;
    blogSectionBlogsRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSectionBlogs2ItemWrapper?: (item: BlogSectionBlogs2Item, content: ReactNode) => ReactNode;
    blogSectionBlogs2Renderer?: (defaultNode: ReactNode) => ReactNode;
    blogSectionBlogs3ItemWrapper?: (item: BlogSectionBlogs3Item, content: ReactNode) => ReactNode;
    blogSectionBlogs3Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeFifteenBlogSectionGenerated: FC<HomeFifteenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Blog & News",
    sectionDiv0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0H20H2Text = "Discover Trends, Tips, And",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Industry News",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "blog",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/blog/blog-img-4.jpg",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0Div1H30Link0LinkHref = "all_routes.blogDetails",
    sectionDiv0Div1Div0Div0Div1H30Link0LinkText = "Finding Balance: Simple Ways To Improve Your Mental Health",
    sectionDiv0Div1Div0Div0Div1H30Link0LinkVisible,
    sectionDiv0Div1Div0Div0Div1H30Link0LinkRenderer,
    sectionDiv0Div1Div0Div0Div1H30Link0LinkProps,
    sectionDiv0Div1Div0Div0Div1Link0LinkHref = "#",
    sectionDiv0Div1Div0Div0Div1Link0LinkText = "Trauma & Recovery",
    sectionDiv0Div1Div0Div0Div1Link0LinkVisible,
    sectionDiv0Div1Div0Div0Div1Link0LinkRenderer,
    sectionDiv0Div1Div0Div0Div1Link0LinkProps,
    sectionDiv0Div1Div0Div0Div1Link1LinkAriaLabel = "Learn More",
    sectionDiv0Div1Div0Div0Div1Link1LinkHref = "all_routes.blogDetails",
    sectionDiv0Div1Div0Div0Div1Link1LinkText = "Learn More",
    sectionDiv0Div1Div0Div0Div1Link1LinkVisible,
    sectionDiv0Div1Div0Div0Div1Link1LinkRenderer,
    sectionDiv0Div1Div0Div0Div1Link1LinkProps,
    sectionDiv0Div1Div0Div0DivDataWowDuration = "2s",
    sectionDiv0Div1Div1Div0Div0H30Link0LinkHref = "all_routes.blogDetails",
    sectionDiv0Div1Div1Div0Div0H30Link0LinkText = "Building Emotional Strength For Our Lives Through Self Care",
    sectionDiv0Div1Div1Div0Div0H30Link0LinkVisible,
    sectionDiv0Div1Div1Div0Div0H30Link0LinkRenderer,
    sectionDiv0Div1Div1Div0Div0H30Link0LinkProps,
    sectionDiv0Div1Div1Div0Div0Link0LinkHref = "#",
    sectionDiv0Div1Div1Div0Div0Link0LinkText = "Addiction & Recovery",
    sectionDiv0Div1Div1Div0Div0Link0LinkVisible,
    sectionDiv0Div1Div1Div0Div0Link0LinkRenderer,
    sectionDiv0Div1Div1Div0Div0Link0LinkProps,
    sectionDiv0Div1Div1Div0Div0Link1LinkAriaLabel = "Learn More",
    sectionDiv0Div1Div1Div0Div0Link1LinkHref = "all_routes.blogDetails",
    sectionDiv0Div1Div1Div0Div0Link1LinkText = "Learn More",
    sectionDiv0Div1Div1Div0Div0Link1LinkVisible,
    sectionDiv0Div1Div1Div0Div0Link1LinkRenderer,
    sectionDiv0Div1Div1Div0Div0Link1LinkProps,
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageAlt = "blog",
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/blog/blog-img-5.jpg",
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0DivDataWowDuration = "2s",
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageAlt = "blog",
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/blog/blog-img-6.jpg",
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div2Div0Div1H30Link0LinkHref = "all_routes.blogDetails",
    sectionDiv0Div1Div2Div0Div1H30Link0LinkText = "The Importance Of Mental Health In Everyday Life Explained",
    sectionDiv0Div1Div2Div0Div1H30Link0LinkVisible,
    sectionDiv0Div1Div2Div0Div1H30Link0LinkRenderer,
    sectionDiv0Div1Div2Div0Div1H30Link0LinkProps,
    sectionDiv0Div1Div2Div0Div1Link0LinkHref = "#",
    sectionDiv0Div1Div2Div0Div1Link0LinkText = "Mental Health Awareness",
    sectionDiv0Div1Div2Div0Div1Link0LinkVisible,
    sectionDiv0Div1Div2Div0Div1Link0LinkRenderer,
    sectionDiv0Div1Div2Div0Div1Link0LinkProps,
    sectionDiv0Div1Div2Div0Div1Link1LinkAriaLabel = "Learn More",
    sectionDiv0Div1Div2Div0Div1Link1LinkHref = "all_routes.blogDetails",
    sectionDiv0Div1Div2Div0Div1Link1LinkText = "Learn More",
    sectionDiv0Div1Div2Div0Div1Link1LinkVisible,
    sectionDiv0Div1Div2Div0Div1Link1LinkRenderer,
    sectionDiv0Div1Div2Div0Div1Link1LinkProps,
    sectionDiv0Div1Div2Div0DivDataWowDuration = "2s",
    sectionImageWithBasePath0ImageAlt = "round-element-1",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/round-element-3.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "round-element-1",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/about-img-two.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "round-element-1",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/about-img-two.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionDiv0Div1Div0Div0Div1H30H3Visible,
    sectionDiv0Div1Div0Div0Div1H30H3Renderer,
    sectionDiv0Div1Div0Div0Div1H30H3Props,
    sectionDiv0Div1Div1Div0Div0H30H3Visible,
    sectionDiv0Div1Div1Div0Div0H30H3Renderer,
    sectionDiv0Div1Div1Div0Div0H30H3Props,
    sectionDiv0Div1Div2Div0Div1H30H3Visible,
    sectionDiv0Div1Div2Div0Div1H30H3Renderer,
    sectionDiv0Div1Div2Div0Div1H30H3Props,
    sectionDiv0Div1ClassName,
    blogSectionBlogs,
    blogSectionBlogs2,
    blogSectionBlogs3,
    blogSectionBlogsItemWrapper,
    blogSectionBlogsRenderer,
    blogSectionBlogs2ItemWrapper,
    blogSectionBlogs2Renderer,
    blogSectionBlogs3ItemWrapper,
    blogSectionBlogs3Renderer,
}) => {
    return (
        <section className="section blog-section-fifteen">
            <div className="container">
                <div className="section-header section-header-fifteen text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    <div className="col-lg-12">
                        <div className="blog-item-fifteen wow fadeInUp" data-wow-duration={sectionDiv0Div1Div0Div0DivDataWowDuration}>
                            <div className="blog-img">
                                {renderNode(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className="blog-content">
                                {renderNode(sectionDiv0Div1Div0Div0Div1Link0LinkVisible, sectionDiv0Div1Div0Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div0Div0Div1Link0LinkHref} className="blog-tag" {...(sectionDiv0Div1Div0Div0Div1Link0LinkProps ?? {})}>{sectionDiv0Div1Div0Div0Div1Link0LinkText}</SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div1Div0Div0Div1H30H3Visible, sectionDiv0Div1Div0Div0Div1H30H3Renderer, (
                                    <h3 className="blog-title" {...(sectionDiv0Div1Div0Div0Div1H30H3Props ?? {})}>
                                        {renderNode(sectionDiv0Div1Div0Div0Div1H30Link0LinkVisible, sectionDiv0Div1Div0Div0Div1H30Link0LinkRenderer, (
                                            <SmartLink href={sectionDiv0Div1Div0Div0Div1H30Link0LinkHref} {...(sectionDiv0Div1Div0Div0Div1H30Link0LinkProps ?? {})}>{sectionDiv0Div1Div0Div0Div1H30Link0LinkText}</SmartLink>
                                        ))}
                                    </h3>
                                ))}
                                <div className="blog-info">
                                    {renderCollectionNode(
                                        blogSectionBlogs,
                                        (item: BlogSectionBlogsItem) => (
                                            <p className={item.pClassName ?? "blog-text"} key={item.key}>
                                                <i className={item.className} />
                                                {item.pText}
                                            </p>
                                        ),
                                        blogSectionBlogsItemWrapper,
                                        blogSectionBlogsRenderer
                                    )}
                                </div>
                                {renderNode(sectionDiv0Div1Div0Div0Div1Link1LinkVisible, sectionDiv0Div1Div0Div0Div1Link1LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div0Div0Div1Link1LinkHref} className="btn btn-white" aria-label={sectionDiv0Div1Div0Div0Div1Link1LinkAriaLabel} {...(sectionDiv0Div1Div0Div0Div1Link1LinkProps ?? {})}>
                                        {sectionDiv0Div1Div0Div0Div1Link1LinkText}
                                        {" "}
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-1" />
                                        </span>
                                        {" "}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="blog-item-fifteen dark-blog wow fadeInUp" data-wow-duration={sectionDiv0Div1Div1Div0DivDataWowDuration}>
                            <div className="blog-content">
                                {renderNode(sectionDiv0Div1Div1Div0Div0Link0LinkVisible, sectionDiv0Div1Div1Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div1Div0Div0Link0LinkHref} className="blog-tag" {...(sectionDiv0Div1Div1Div0Div0Link0LinkProps ?? {})}>{sectionDiv0Div1Div1Div0Div0Link0LinkText}</SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div1Div1Div0Div0H30H3Visible, sectionDiv0Div1Div1Div0Div0H30H3Renderer, (
                                    <h3 className="blog-title" {...(sectionDiv0Div1Div1Div0Div0H30H3Props ?? {})}>
                                        {renderNode(sectionDiv0Div1Div1Div0Div0H30Link0LinkVisible, sectionDiv0Div1Div1Div0Div0H30Link0LinkRenderer, (
                                            <SmartLink href={sectionDiv0Div1Div1Div0Div0H30Link0LinkHref} {...(sectionDiv0Div1Div1Div0Div0H30Link0LinkProps ?? {})}>{sectionDiv0Div1Div1Div0Div0H30Link0LinkText}</SmartLink>
                                        ))}
                                    </h3>
                                ))}
                                <div className="blog-info">
                                    {renderCollectionNode(
                                        blogSectionBlogs2,
                                        (item: BlogSectionBlogs2Item) => (
                                            <p className={item.pClassName ?? "blog-text"} key={item.key}>
                                                <i className={item.className} />
                                                {item.pText}
                                            </p>
                                        ),
                                        blogSectionBlogs2ItemWrapper,
                                        blogSectionBlogs2Renderer
                                    )}
                                </div>
                                {renderNode(sectionDiv0Div1Div1Div0Div0Link1LinkVisible, sectionDiv0Div1Div1Div0Div0Link1LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div1Div0Div0Link1LinkHref} className="btn btn-white" aria-label={sectionDiv0Div1Div1Div0Div0Link1LinkAriaLabel} {...(sectionDiv0Div1Div1Div0Div0Link1LinkProps ?? {})}>
                                        {sectionDiv0Div1Div1Div0Div0Link1LinkText}
                                        {" "}
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-1" />
                                        </span>
                                        {" "}
                                    </SmartLink>
                                ))}
                            </div>
                            <div className="blog-img">
                                {renderNode(sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div1Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="blog-item-fifteen mb-0 wow fadeInUp" data-wow-duration={sectionDiv0Div1Div2Div0DivDataWowDuration}>
                            <div className="blog-img">
                                {renderNode(sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div2Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className="blog-content">
                                {renderNode(sectionDiv0Div1Div2Div0Div1Link0LinkVisible, sectionDiv0Div1Div2Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div2Div0Div1Link0LinkHref} className="blog-tag" {...(sectionDiv0Div1Div2Div0Div1Link0LinkProps ?? {})}>{sectionDiv0Div1Div2Div0Div1Link0LinkText}</SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div1Div2Div0Div1H30H3Visible, sectionDiv0Div1Div2Div0Div1H30H3Renderer, (
                                    <h3 className="blog-title" {...(sectionDiv0Div1Div2Div0Div1H30H3Props ?? {})}>
                                        {renderNode(sectionDiv0Div1Div2Div0Div1H30Link0LinkVisible, sectionDiv0Div1Div2Div0Div1H30Link0LinkRenderer, (
                                            <SmartLink href={sectionDiv0Div1Div2Div0Div1H30Link0LinkHref} {...(sectionDiv0Div1Div2Div0Div1H30Link0LinkProps ?? {})}>{sectionDiv0Div1Div2Div0Div1H30Link0LinkText}</SmartLink>
                                        ))}
                                    </h3>
                                ))}
                                <div className="blog-info">
                                    {renderCollectionNode(
                                        blogSectionBlogs3,
                                        (item: BlogSectionBlogs3Item) => (
                                            <p className={item.pClassName ?? "blog-text"} key={item.key}>
                                                <i className={item.className} />
                                                {item.pText}
                                            </p>
                                        ),
                                        blogSectionBlogs3ItemWrapper,
                                        blogSectionBlogs3Renderer
                                    )}
                                </div>
                                {renderNode(sectionDiv0Div1Div2Div0Div1Link1LinkVisible, sectionDiv0Div1Div2Div0Div1Link1LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div2Div0Div1Link1LinkHref} className="btn btn-white" aria-label={sectionDiv0Div1Div2Div0Div1Link1LinkAriaLabel} {...(sectionDiv0Div1Div2Div0Div1Link1LinkProps ?? {})}>
                                        {sectionDiv0Div1Div2Div0Div1Link1LinkText}
                                        {" "}
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-1" />
                                        </span>
                                        {" "}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="round-element-1 img-fluid" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="round-element-2 img-fluid" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="round-element-3 img-fluid" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFifteenBlogSectionGenerated;
